var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-medal-box" },
    [
      _c("yxtf-image", {
        staticClass: "yxtbiz-medal-box_icon",
        attrs: { src: _vm.data.activeIcon, fit: "cover" },
      }),
      _c(
        "yxtf-tooltip",
        { attrs: { "open-filter": "", content: _vm.title, placement: "top" } },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-medal-box_title ellipsis nowrap" },
            [
              _vm._v(_vm._s(_vm.title)),
              _vm.data.missionCategoryCode === "day_day_up" && _vm.isSelf
                ? [
                    _c(
                      "yxt-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("pc_biz_lbl_mycontinuedays", [
                            _vm.myContinueDays,
                          ]),
                          placement: "top",
                        },
                      },
                      [
                        _c("yxt-svg", {
                          staticClass: "ml4 color-gray-7 hand",
                          attrs: {
                            "icon-class": "question-cirlce-o",
                            width: "16px",
                            height: "16px",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _c(
        "yxtf-tooltip",
        {
          attrs: {
            "open-filter": "",
            content: _vm.data.description,
            placement: "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-medal-box_count ellipsis-2 break-word" },
            [_vm._v(_vm._s(_vm.data.description))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }